var map = {
	"./1+1.svg": 135,
	"./2+1.svg": 136,
	"./2+2.svg": 137,
	"./achieve.svg": 138,
	"./arrow-back.svg": 139,
	"./baget.svg": 140,
	"./beer.svg": 141,
	"./breacfast.svg": 142,
	"./bread.svg": 143,
	"./burger-1.svg": 144,
	"./burger-red-1.svg": 145,
	"./burger.svg": 146,
	"./cal-check.svg": 147,
	"./champagne.svg": 148,
	"./cocktail.svg": 149,
	"./coin.svg": 150,
	"./cola.svg": 151,
	"./coupon-10.svg": 152,
	"./coupon-100.svg": 153,
	"./coupon-20.svg": 154,
	"./coupon-50.svg": 155,
	"./croissant.svg": 156,
	"./darkbread.svg": 157,
	"./diamond.svg": 158,
	"./emotionless-smile.svg": 159,
	"./enjoy.svg": 160,
	"./euro.svg": 161,
	"./fish-1.svg": 162,
	"./fish.svg": 163,
	"./gift-outlined.svg": 164,
	"./gift.svg": 165,
	"./hand-finder.svg": 166,
	"./heart.svg": 167,
	"./hotdog.svg": 168,
	"./icecream-1.svg": 169,
	"./icecream.svg": 170,
	"./king.svg": 171,
	"./notification.svg": 172,
	"./pasta.svg": 173,
	"./percent.svg": 174,
	"./pie.svg": 175,
	"./pizza.svg": 176,
	"./pommes.svg": 177,
	"./red-pocket.svg": 178,
	"./salad.svg": 179,
	"./semmel.svg": 180,
	"./smile.svg": 181,
	"./soup.svg": 182,
	"./steak.svg": 183,
	"./sushibox.svg": 184,
	"./tea.svg": 185,
	"./wine-bottle.svg": 186,
	"./wine.svg": 187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;